export const CLIENT_CSV_FILE_REQUEST = "CLIENT_CSV_FILE_REQUEST";
export const CLIENT_CSV_FILE_SUCCESS = "CLIENT_CSV_FILE_SUCCESS";
export const CLIENT_CSV_FILE_FAILURE = "CLIENT_CSV_FILE_FAILURE";
